import { RowCrudStatus } from "../../common/types";
import { BotStep } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { FileCRUDType, fileCRUDInit } from "../../common/types";
import { formatBytes } from "../../../common/utils";

let uniqueCounter = 1;
export type BotStepValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  downloadedFile: string;
  downloadedFile_data: FileCRUDType;
  __downloadedFile_files: FileCRUDType[];
};

export type BotStepErrorsType = {
  downloadedFile?: { message: string; fieldLabel: string };
};

export function BotStepValuesInit(): BotStepValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    downloadedFile: "",
    downloadedFile_data: fileCRUDInit(),
    __downloadedFile_files: [],
  };
}

export type BotStepType = BotStep | BotStepValuesType;

export function botStepDisplayId(
  source: Partial<BotStep>,
  _langStore: LangStore
) {
  return (
    (source.stepNumber?.toString() ?? _langStore.emptyStringSymbol) +
    "-" +
    (source.stepId ?? _langStore.emptyStringSymbol)
  );
}

export function getBotStepValues(
  source: BotStepType,
  _langStore: LangStore,
  _duplicated: boolean = false
): BotStepValuesType {
  const entityValues = BotStepValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : botStepDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.__downloadedFile_files =
    source.downloadedFile_data && !_duplicated
      ? [
          {
            id:
              "id" in source.downloadedFile_data &&
              source.downloadedFile_data.id
                ? source.downloadedFile_data.id
                : `generated_${uniqueCounter++}`,
            name: source.downloadedFile_data.name,
            description: source.downloadedFile_data.description || undefined,
            size: source.downloadedFile_data.size || 0,
            formattedSize: source.downloadedFile_data.size
              ? formatBytes(source.downloadedFile_data.size)
              : "",
            mimetype: source.downloadedFile_data.mimetype,
            url: source.downloadedFile_data.url || undefined,
            __status__: "original",
          },
        ]
      : [];
  entityValues.downloadedFile =
    source.downloadedFile && !_duplicated ? source.downloadedFile : "";
  entityValues.downloadedFile_data =
    source.downloadedFile_data && "__status__" in source.downloadedFile_data
      ? source.downloadedFile_data
      : source.downloadedFile_data
      ? {
          id: ("id" in source.downloadedFile_data &&
          source.downloadedFile_data.id
            ? source.downloadedFile_data.id
            : `generated_${uniqueCounter++}`) as string,
          name: source.downloadedFile_data.name,
          description: source.downloadedFile_data.description || undefined,
          size: source.downloadedFile_data.size || 0,
          formattedSize: source.downloadedFile_data.size
            ? formatBytes(source.downloadedFile_data.size)
            : "",
          mimetype: source.downloadedFile_data.mimetype,
          url: source.downloadedFile_data.url || undefined,
          __status__: "original" as RowCrudStatus,
        }
      : fileCRUDInit();
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
